import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { commonQueryKeys } from "@/common/data/commonQueryKeys";
import api from "@/common/utils/api";
import { UserName } from "@reflag/shared/userAPI";

function usersWithNames(
  ids: string[] | undefined,
  data: UserName[] | undefined,
  placeholder?: boolean,
) {
  return ids?.map((id) => {
    const prevUser = data?.find((c) => c.id === id);
    return {
      name: null,
      email: null,
      avatarUrl: null,
      ...prevUser,
      id,
      isUnknown: prevUser?.isUnknown ?? (!placeholder && !prevUser),
    };
  });
}

export function useUserNamesData(ids?: string[], envIdOverride?: string) {
  const { appId, envId: currentEnvId } = useEnvironment();
  const envId = envIdOverride ?? currentEnvId;

  return useQuery({
    queryKey: commonQueryKeys.userNames(appId, envId, ids),
    queryFn: () =>
      api
        .post<`/apps/:appId/user-names`>(
          `/apps/${appId}/user-names`,
          {
            ids: ids as [string, ...string[]],
          },
          {
            params: { envId: envId! },
          },
        )
        .then((res) => usersWithNames(ids, res.data, false)),
    enabled: !!appId && !!envId && !!ids?.length,
    placeholderData: (previousData) => usersWithNames(ids, previousData, true),
    staleTime: 1000,
  });
}
